
/**
 * @sveltech/routify 1.9.10
 * File generated Sun Jul 31 2022 18:58:32 GMT+0200 (közép-európai nyári idő)
 */

export const __version = "1.9.10"
export const __timestamp = "2022-07-31T16:58:32.216Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports
import __fallback from '../../../../src/pages/_fallback.svelte'
import __layout from '../../../../src/pages/_layout.svelte'
import _contact from '../../../../src/pages/contact.svelte'
import _gallery_ajto from '../../../../src/pages/gallery/ajto.svelte'
import _gallery_dekor from '../../../../src/pages/gallery/dekor.svelte'
import _gallery_egyeb from '../../../../src/pages/gallery/egyeb.svelte'
import _gallery_fal from '../../../../src/pages/gallery/fal.svelte'
import _gallery_korlat from '../../../../src/pages/gallery/korlat.svelte'
import _gallery_zuhany from '../../../../src/pages/gallery/zuhany.svelte'
import _index from '../../../../src/pages/index.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {},
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "file": "_fallback.svelte",
      "filepath": "/_fallback.svelte",
      "name": "_fallback",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/_fallback.svelte",
      "importPath": "../../../../src/pages/_fallback.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": true,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/_fallback",
      "id": "__fallback",
      "component": () => __fallback
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "_layout.svelte",
      "filepath": "/_layout.svelte",
      "name": "_layout",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/_layout.svelte",
      "importPath": "../../../../src/pages/_layout.svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/",
      "id": "__layout",
      "component": () => __layout
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "contact.svelte",
      "filepath": "/contact.svelte",
      "name": "contact",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/contact.svelte",
      "importPath": "../../../../src/pages/contact.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/contact",
      "id": "_contact",
      "component": () => _contact
    },
    {
      "isFile": false,
      "isDir": true,
      "file": "gallery",
      "filepath": "/gallery",
      "name": "gallery",
      "ext": "",
      "badExt": false,
      "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "file": "ajto.svelte",
          "filepath": "/gallery/ajto.svelte",
          "name": "ajto",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/ajto.svelte",
          "importPath": "../../../../src/pages/gallery/ajto.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/ajto",
          "id": "_gallery_ajto",
          "component": () => _gallery_ajto
        },
        {
          "isFile": true,
          "isDir": false,
          "file": "dekor.svelte",
          "filepath": "/gallery/dekor.svelte",
          "name": "dekor",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/dekor.svelte",
          "importPath": "../../../../src/pages/gallery/dekor.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/dekor",
          "id": "_gallery_dekor",
          "component": () => _gallery_dekor
        },
        {
          "isFile": true,
          "isDir": false,
          "file": "egyeb.svelte",
          "filepath": "/gallery/egyeb.svelte",
          "name": "egyeb",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/egyeb.svelte",
          "importPath": "../../../../src/pages/gallery/egyeb.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/egyeb",
          "id": "_gallery_egyeb",
          "component": () => _gallery_egyeb
        },
        {
          "isFile": true,
          "isDir": false,
          "file": "fal.svelte",
          "filepath": "/gallery/fal.svelte",
          "name": "fal",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/fal.svelte",
          "importPath": "../../../../src/pages/gallery/fal.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/fal",
          "id": "_gallery_fal",
          "component": () => _gallery_fal
        },
        {
          "isFile": true,
          "isDir": false,
          "file": "korlat.svelte",
          "filepath": "/gallery/korlat.svelte",
          "name": "korlat",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/korlat.svelte",
          "importPath": "../../../../src/pages/gallery/korlat.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/korlat",
          "id": "_gallery_korlat",
          "component": () => _gallery_korlat
        },
        {
          "isFile": true,
          "isDir": false,
          "file": "zuhany.svelte",
          "filepath": "/gallery/zuhany.svelte",
          "name": "zuhany",
          "ext": "svelte",
          "badExt": false,
          "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/gallery/zuhany.svelte",
          "importPath": "../../../../src/pages/gallery/zuhany.svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true
          },
          "path": "/gallery/zuhany",
          "id": "_gallery_zuhany",
          "component": () => _gallery_zuhany
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/gallery"
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "index.svelte",
      "filepath": "/index.svelte",
      "name": "index",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "D:/GIT/Web/uvegszerviz/src/pages/index.svelte",
      "importPath": "../../../../src/pages/index.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => _index
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

